import { windowWidth } from "./utils";
enum AccordianType {
  ONE_OPEN = "one-open",
  ALL_OPEN = "all-open",
}

const accordian = {
  accordian: document.querySelectorAll(
    ".jsAccordian"
  ) as NodeListOf<HTMLElement>,
  scrollToEl: undefined as HTMLElement | undefined,
  init() {
    this.setAccordian();
  },
  setAccordian() {
    this.accordian.forEach((item) => {
      const width = item.dataset.width ? item.dataset.width : "999999";
      const offset = item.dataset.offset;

      if (windowWidth < parseInt(width)) {
        const items = item.querySelectorAll(
          ".jsAccordianItem"
        ) as NodeListOf<HTMLElement>;
        const type = item.dataset.type as AccordianType | undefined;
        this.setItems(items, type);
        if(offset){
            item.addEventListener("transitionend", () => { this.scrollPosition(offset)});
        }
      }
    });
  },
  setItems(items: NodeListOf<HTMLElement>, type: AccordianType | undefined) {
    items.forEach((item, index) => {
      const parent = item.parentElement as HTMLElement;
      const sibiling = item.nextElementSibling as HTMLElement;
      const sibilingHeight = sibiling.offsetHeight;
      const height = item.offsetHeight;
      let open: number | null = null;
      if (item.dataset.open === "true") {
        parent.style.maxHeight = height + sibilingHeight + "px";
        item.classList.add("activeClass");
      }

      item.addEventListener("click", (e) => {
        e.preventDefault();

        if (type === AccordianType.ONE_OPEN) {
          this.closeAll(items);
        }
        if (open !== index) {
          open = index;
          this.scrollToEl = parent
          item.dataset.open = "true";
          parent.style.maxHeight = height + sibilingHeight + "px";
          item.classList.add("activeClass");
        } else {
          open = null;
          this.scrollToEl = undefined
          item.dataset.open = "false";
          parent.style.maxHeight = height + "px";
          item.classList.remove("activeClass");
        }
      });
    });
  },
  closeAll(items: NodeListOf<HTMLElement>) {
    items.forEach((item) => {
      const parent = item.parentElement as HTMLElement;
      const height = item.offsetHeight;
      item.dataset.open = "false";
      parent.style.maxHeight = height + "px";
      item.classList.remove("activeClass");
    });
  },
  scrollPosition(offset: string ) {
    if (this.scrollToEl) {
      window.scrollTo({
        top: this.scrollToEl.offsetTop - +offset,
        behavior: "smooth",
      });
    }
  },
};

export default accordian;
